import SectionPage from "./SectionPage";
import WhyFreshFast from "./WhyFreshFast";

export const WhyUsPage = () => (
  <SectionPage
    eyebrow="Why Fresh Fast Foods"
    title="Food Service Experience You Can Trust"
    subtitle="The speed and consistency of BTWNYC quick-service operations, paired with the flexibility of custom catering — built around timing, packaging, and showing up ready."
    hero="cream"
  >
    <WhyFreshFast compact />
  </SectionPage>
);

export default WhyUsPage;
